import React, { useEffect, useState, useCallback, useContext } from 'react';
import {
  DASHBOARD_SPONSORSHIPS_COUNT, DASHBOARD_SPONSORS_COUNT, DASHBOARD_YTD_PAYMENTS,
  DASHBOARD_REGUSERS_COUNT, DASHBOARD_PAST_PAYMENTS, DASHBOARD_PAYMENTS_BY_DONATIONCAUSE,
  DASHBOARD_PAYMENTS_BY_DONATIONCAUSE_BY_MONTH, DASHBOARD_PAYMENTS_BY_DONATIONCAUSE_YTD
} from 'config/config';
import { extractError } from 'api/ErrorUtil';
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Form,
  OverlayTrigger,
} from "react-bootstrap";

import { Tooltip as Tooltipb } from 'react-bootstrap';

import { API } from 'api/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChildren, faHandHoldingHeart, faPeopleGroup, faSackDollar } from '@fortawesome/free-solid-svg-icons';
import { evenRound } from 'util/NumberUtils';
import { formatCurrency } from 'util/Currency';
import { TenantContext } from 'tenant/TenantContext';
import _ from "lodash";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from 'chart.js';
import { Line, Bar, Pie } from 'react-chartjs-2';
import { getThreeLetterMonthsWithYear, getMonthsInCurrentYear } from 'util/Date';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BusinessHome = () => {

  const lastSixMonthNames = getThreeLetterMonthsWithYear(6);
  const ytdMonths = getThreeLetterMonthsWithYear(12);

  const initialPageState = {
    errors: {},
    infoMessage: ""
  }

  const generateColors = (numberOfColors) => {
    const backgroundColors = [];
    const borderColors = [];
    for (let i = 0; i < numberOfColors; i++) {
        const {backgroundColor, borderColor} = generateBackgroundAndBorderColor();
        backgroundColors.push(backgroundColor);
        borderColors.push(borderColor);
    }
    return { backgroundColors, borderColors };
}

const generateBackgroundAndBorderColor = () => {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    const darkerR = Math.floor(r * 0.8);
    const darkerG = Math.floor(g * 0.8);
    const darkerB = Math.floor(b * 0.8);
    return {backgroundColor:`rgba(${r},${g},${b},0.2)`,borderColor:`rgb(${darkerR},${darkerG},${darkerB})`};
}

  const { businessConfig } = useContext(TenantContext);
  const [pageState, setPageState] = useState(initialPageState);
  const [sponsorshipCount, setSponsorshipCount] = useState(0);
  const [sponsorCount, setSponsorCount] = useState(0)
  const [ytdPayments, setYtdPayments] = useState(0.00);
  const [registeredUsersCount, setRegisteredUsersCount] = useState(0.00);
  const [lineChartData, setLineChartData] = useState({});
  const [lineChartOptons, setLineChartOptions] = useState({});
  const [barChartData, setBarChartData] = useState({});
  const [barChartOptions, setBarChartOptions] = useState({});
  const [pieChartData, setPieChartData] = useState({});
  const [pieChartOptions, setPieChartOptions] = useState({});
  const [paymentsByCauseYtd, setPaymentsByCauseYtd] = useState({});
  
  const messageReset = () => {
    return {
      infoMessage: "",
      errors: {}
    }
  }

  const onToastClose = () => {
    setPageState({
      ...pageState,
      ...messageReset()
    });
  }

  const fetchSponsorshipCount = useCallback(async () => {
    try {
      let sponsorshipCount = await API.get(DASHBOARD_SPONSORSHIPS_COUNT);
      setSponsorshipCount(sponsorshipCount.data);
    } catch (ex) {
      let errors = extractError(ex);
      setPageState({
        errors: errors
      })
      setSponsorshipCount(0);
    }
  })

  const fetchYtdPayments = useCallback(async () => {
    try {
      let yearToDatePayments = await API.get(DASHBOARD_YTD_PAYMENTS);
      setYtdPayments(evenRound(parseFloat(yearToDatePayments.data) / parseFloat(100), 2));

    } catch (ex) {
      let errors = extractError(ex);
      setPageState({
        errors: errors
      })
      setYtdPayments(0.00);
    }
  })

  const fetchSponsorsCount = useCallback(async () => {
    try {
      let sponsorsCount = await API.get(DASHBOARD_SPONSORS_COUNT);
      setSponsorCount(sponsorsCount.data);
    } catch (ex) {
      let errors = extractError(ex);
      setPageState({
        errors: errors
      })
      setSponsorCount(0);
    }
  })

  const fetchRegisteredUsersCount = useCallback(async () => {
    try {
      let regUsersCount = await API.get(DASHBOARD_REGUSERS_COUNT);
      setRegisteredUsersCount(regUsersCount.data);
    } catch (ex) {
      let errors = extractError(ex);
      setPageState({
        errors: errors
      })
      setSponsorCount(0);
    }
  })

  const fetchDonationCauseChartData = useCallback(async () => {
    let labels = lastSixMonthNames;
    
    try {
      let pastPayments = await API.get(DASHBOARD_PAYMENTS_BY_DONATIONCAUSE_BY_MONTH);
      const chartData = [];
      pastPayments.data.forEach(item => {
        const key = item.donationCauseCode;
        if (!chartData[key]) {
          const {backgroundColor, borderColor} = generateBackgroundAndBorderColor();
          chartData[key] = {
            label: key,
            data: Array(lastSixMonthNames.length).fill(0),
            backgroundColor:  backgroundColor,
            borderColor: borderColor,
          };
        }
        let monthIndex = lastSixMonthNames.indexOf(item.month);
        chartData[key].data[monthIndex] = evenRound(parseFloat(item.payments) / parseFloat(100), 2);
      });

      setLineChartOptions({
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: false,
            text: 'Chart.js Line Chart',
          },
        },
      });
  
      setLineChartData({
        labels,
        datasets: Object.keys(chartData).map((key, index) => (chartData[key])),
      });
    } catch (ex) {
      let errors = extractError(ex);
      setPageState({
        errors: errors
      })
    }

    
  });

  const fetchPaymentChartData = useCallback(async () => {
    let labels = lastSixMonthNames;
    let data = [0, 0, 0, 0, 0, 0];
    try {
      let pastPayments = await API.get(DASHBOARD_PAST_PAYMENTS);
      for (let { month, payments } of pastPayments.data) {

        const index = labels.indexOf(month);
        if (index !== -1) {
          data[index] = evenRound(parseFloat(payments) / parseFloat(100), 2);
        } else {
          labels.push(month);
          data.push(evenRound(parseFloat(payments) / parseFloat(100), 2));
        }
      }
      const {backgroundColors, borderColors} = generateColors(lastSixMonthNames.length);
      setBarChartData({
        labels: labels,
        datasets: [{
          label: '',
          data: data,
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1
        }]
      });
  
      setBarChartOptions({
        responsive: true,
        plugins: {
          legend: {
            display: false,
            position: 'top',
          },
          title: {
            display: false,
            text: 'Chart.js Line Chart',
          },
        },
      });
    } catch (ex) {
      let errors = extractError(ex);
      setPageState({
        errors: errors
      })
    }
    

  });

  const fetchPieChartData = useCallback(async () => {
    let data = [];
    let labels = [];
    try {
      let paymentsByDonationCause = await API.get(DASHBOARD_PAYMENTS_BY_DONATIONCAUSE);
      const totalPayments = paymentsByDonationCause.data.reduce((acc, curr) => acc + curr.payments, 0)
      paymentsByDonationCause.data.forEach(donation => {
        labels.push(donation.donationCauseCode);
        let donationPayments = (donation.payments / totalPayments) * 100
        data.push(donationPayments.toFixed(2));
      });

      const {backgroundColors, borderColors} = generateColors(labels.length);
      setPieChartData({
        labels: labels,
        datasets: [{
          label: 'Payments by Cause',
          data: data,
          backgroundColor: borderColors,
          hoverOffset: 4
        }]
      });
  
      setPieChartOptions({
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: false,
            text: 'Payments by Donation Cause',
          },
        },
      });
    } catch (ex) {
      let errors = extractError(ex);
      setPageState({
        errors: errors
      })
    }
  });

  const fetchDonationCauseYtdData = useCallback(async () => {
    try {
      let pastPayments = await API.get(DASHBOARD_PAYMENTS_BY_DONATIONCAUSE_YTD);
      const tableData = {};
      pastPayments.data.forEach(item => {
        const key = item.donationCauseCode;
        if (!tableData[key]) {
          tableData[key] = {
            cause: key,
            data: Array(ytdMonths.length).fill(0)
          };
        }
        let monthIndex = ytdMonths.indexOf(item.month);
        tableData[key].data[monthIndex] = evenRound(parseFloat(item.payments) / parseFloat(100), 2);
      });
      setPaymentsByCauseYtd(tableData);
    } catch (ex) {
      let errors = extractError(ex);
      setPageState({
        errors: errors
      })
    }

  });

  useEffect(() => {
    fetchSponsorshipCount();
    fetchYtdPayments();
    fetchSponsorsCount();
    fetchRegisteredUsersCount();
    fetchDonationCauseChartData();
    fetchPaymentChartData();
    fetchPieChartData();
    fetchDonationCauseYtdData();
  }, []);

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <FontAwesomeIcon icon={faChildren} className="nc-icon nc-chart text-warning" />
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category"></p>
                      <Card.Title as="h4">{sponsorshipCount}</Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Sponsorships
                </div>
              </Card.Footer>
            </Card>
          </Col>
          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <FontAwesomeIcon icon={faHandHoldingHeart} className="nc-icon nc-vector text-info" />
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category"></p>
                      <Card.Title as="h4">{sponsorCount}</Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <div className="stats">
                  <i className="far fa-clock-o mr-1"></i>
                  Sponsors
                </div>
              </Card.Footer>
            </Card>
          </Col>

          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-info">
                      <FontAwesomeIcon icon={faSackDollar} className="nc-icon nc-light-3 text-success" />
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category"></p>
                      <Card.Title as="h4">{formatCurrency(ytdPayments, businessConfig.locale, businessConfig.currency)}</Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <div className="stats">
                  <i className="far fa-calendar-alt mr-1"></i>
                  Total Payments Year to Date
                </div>
              </Card.Footer>
            </Card>
          </Col>
          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <FontAwesomeIcon icon={faPeopleGroup} className="nc-icon nc-favourite-28 text-primary" />
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category"></p>
                      <Card.Title as="h4">{registeredUsersCount}</Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Registered Users
                </div>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="8" className="h-100">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Total Payments</Card.Title>
                <p className="card-category">Past 6 months</p>
              </Card.Header>
              <Card.Body>
                <div>
                  {!_.isEmpty(barChartData) && !_.isEmpty(barChartOptions) && <Bar options={barChartOptions} data={barChartData} />}
                </div>
              </Card.Body>
              <Card.Footer>
                <div className="legend">
                </div>
                <hr></hr>
                <div className="stats">
                </div>
              </Card.Footer>
            </Card>
          </Col>
          <Col md="4" className="h-100">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Payments by Donation Cause</Card.Title>
                <p className="card-category">Past Six Months</p>
              </Card.Header>
              <Card.Body>
                <div>
                  {!_.isEmpty(pieChartData) && !_.isEmpty(pieChartOptions) && <Pie options={pieChartOptions} data={pieChartData} />}
                </div>
              </Card.Body>
              <Card.Footer>
                <div className="legend">
                </div>
                <hr></hr>
                <div className="stats">
                </div>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Past Six Months Donations by Cause</Card.Title>
                <p className="card-category">Monthly</p>
              </Card.Header>
              <Card.Body>
                <div>
                  {!_.isEmpty(lineChartData) && !_.isEmpty(lineChartOptons) && <Line options={lineChartOptons} data={lineChartData} />}
                </div>
              </Card.Body>
              <Card.Footer>
                <div className="legend">
                </div>
                <hr></hr>
                <div className="stats">
                  <i className="fas fa-history"></i>
                </div>
              </Card.Footer>
            </Card>
          </Col>

        </Row>
        <Row>
          <Col>
            <Card className="card-tasks" style={{ overflowX: 'auto' }}>
              <Card.Header>
                <Card.Title as="h4">Payments by Donation Cause</Card.Title>
                <p className="card-category">Monthly</p>
              </Card.Header>
              <Card.Body>
                <div>
                  <Table striped bordered hover>
                    <tbody>
                      <tr>
                        <th>
                          Cause/Month
                        </th>
                        {ytdMonths.map((month, idx) => (
                          <th key={idx}>
                            {month}
                          </th>))}
                      </tr>
                      {!_.isEmpty(paymentsByCauseYtd) && Object.keys(paymentsByCauseYtd).map((ytdCausePmt,idxc)=>(
                      <tr key={idxc}>
                        <td>
                          {ytdCausePmt}
                        </td>
                        {ytdMonths.map((month, midx) => (
                          <td>
                            {formatCurrency(paymentsByCauseYtd[ytdCausePmt].data[midx], businessConfig.locale, businessConfig.currency)}
                          </td>))}
                        
                      </tr>))}
                    </tbody>
                  </Table>
                  
                </div>
              </Card.Body>
            </Card>


          </Col>
        </Row>
      </Container>
    </>
  );
}


export default BusinessHome